import _defineProperty from "/builds/telavita-core/frontend/core-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import { useTheme } from 'theming';
import useStyles from './styles';
import clsx from 'clsx';

var Paper = function Paper(_ref) {
  var _clsx;

  var children = _ref.children,
      variant = _ref.variant,
      _ref$customClassName = _ref.customClassName,
      customClassName = _ref$customClassName === void 0 ? '' : _ref$customClassName,
      _ref$inlineStyles = _ref.inlineStyles,
      inlineStyles = _ref$inlineStyles === void 0 ? {} : _ref$inlineStyles,
      _ref$regular = _ref.regular,
      regular = _ref$regular === void 0 ? false : _ref$regular;
  var theme = useTheme();
  var classes = useStyles({
    theme: theme
  });
  var containerStyles = clsx((_clsx = {}, _defineProperty(_clsx, classes.container, true), _defineProperty(_clsx, classes[variant], variant && !regular), _defineProperty(_clsx, classes["".concat(variant, "_regular")], variant && regular), _defineProperty(_clsx, classes.default, variant), _defineProperty(_clsx, customClassName, customClassName), _clsx));
  return React.createElement("div", {
    className: containerStyles,
    style: inlineStyles
  }, children);
};

export { Paper };